import { Navigate } from 'react-router-dom'

import { useTagInventoryOverview } from 'hooks/api/useTagInventoryOverview'
import { ROUTES } from 'routes'

/**
 * Picks which Tags tab `/tags` lands on, based on whether the company owns any tags.
 *
 * Inventory is the right default once there is inventory to manage, but it is a dead
 * end for a company that has not bought any tags yet -- they land on an empty table
 * and have to find the Shop tab themselves. So an empty inventory sends them to Shop,
 * which is the only useful action available to them at that point.
 *
 * Renders nothing while the count is loading rather than redirecting to a guess and
 * bouncing: a wrong first redirect would be a visible flash, and worse, `replace`
 * would leave the wrong entry in history.
 */
export const TagsIndexRedirect = () => {
  const { rows, isLoading } = useTagInventoryOverview()

  if (isLoading) return null

  return (
    <Navigate to={rows.length > 0 ? ROUTES.TAGS_INVENTORY : ROUTES.TAGS_SHOP} replace />
  )
}
